export const SortByEnum = {
  ASC: "ASC",
  DESC: "DESC",
};
